import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { AppHeaders } from "@models";
import { Router } from "@angular/router";
import { AuthService, PopupService } from "@services";
import { ROUTES_PATH } from "@enums";
import { LoaderService } from '../services/loader.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  private activeRequest = 0;

  constructor(private authService: AuthService,
              private router: Router,
              private popupService: PopupService,
              private serviceLoader : LoaderService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

  this.activeRequest++;

  if (this.activeRequest === 1) {
    this.serviceLoader.showLoader();
  }

  // Tiempo inicial
  const startTime = performance.now();

  const currentUser = this.authService.currentUserValue;

  //console.log('REQ:', request.method, request.url);

  let headers: any = {};

  if (currentUser?.access_token) {
    headers = {
      Authorization: `Bearer ${currentUser.access_token}`
    };
  }

  const isFormData = request.body instanceof FormData;
  const isBlob = request.responseType === 'blob';

  let modifiedRequest = request;

  if (currentUser?.access_token) {

    if (isFormData || isBlob) {
      modifiedRequest = request.clone({
        setHeaders: headers
      });
    } else {
      modifiedRequest = request.clone({
        setHeaders: {
          ...headers,
          'Content-Type':
            request.method === 'PATCH'
              ? 'application/merge-patch+json'
              : 'application/json'
        }
      });
    }
  }

  return next.handle(modifiedRequest).pipe(

    finalize(() => {

      // Tiempo final
      const elapsed = performance.now() - startTime;

      // console.log(
      //   `[${request.method}] ${request.url} -> ${elapsed.toFixed(0)} ms`
      // );

      this.activeRequest--;

      if (this.activeRequest <= 0) {
        this.activeRequest = 0;
        this.serviceLoader.hideLoader();
      }
    }),

    catchError((err: HttpErrorResponse) => {

      if (err.status === 401 && localStorage.getItem('oneError') !== '1') {

        localStorage.setItem('oneError', '1');

        this.popupService.errorAlert(
          'Debe autenticarse, por favor.',
          5000
        );

        localStorage.clear();

        this.router.navigateByUrl(ROUTES_PATH.SignIn);
      }

      return throwError(() => err);
    })
  );
}
  private stopLoader(){
    this.activeRequest--;
    if(this.activeRequest === 0){
      this.serviceLoader.hideLoader();
    }
  }
}
